import {
    Component,
    NgModuleRef,
    OnDestroy,
    ChangeDetectionStrategy,
} from '@angular/core';
import { ModalService } from 'mnm-webapp';
import { ChatComponent } from '../ai/components/chat/chat.component';
import { TranslateService } from '@ngx-translate/core';
import { AppSettingFetcherService } from '@masar/core/services';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-guide-bot',
    templateUrl: './guide-bot.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class GuideBotComponent implements OnDestroy {
    public isChatOpen = false;
    public isEnabled: boolean = false;

    private unsubscribeAll = new Subject<void>();

    public constructor(
        private readonly modalService: ModalService,
        private readonly moduleRef: NgModuleRef<any>,
        private readonly translateService: TranslateService,
        private appSettingFetcherService: AppSettingFetcherService
    ) {
        this.appSettingFetcherService.get$
            .pipe(takeUntil(this.unsubscribeAll))
            .subscribe(settings => {
                this.isEnabled = settings.aiSetting?.isEnabled;
            });
    }

    public ngOnDestroy(): void {
        this.unsubscribeAll.next();
        this.unsubscribeAll.complete();
    }

    public async openChat(): Promise<void> {
        if (this.isChatOpen || !this.isEnabled) return;
        this.isChatOpen = true;

        this.translateService
            .get(
                'translate_assistant_daleel_ai_powered_bot_to_answer_general_questions'
            )
            .subscribe(async title => {
                await this.modalService.show(ChatComponent, {
                    title,
                    moduleRef: this.moduleRef,
                    beforeInit: c => {
                        c.scheme = 'guide';
                    },
                    onDismiss: () => {
                        this.isChatOpen = false;
                    },
                    size: {
                        width: '50%',
                        height: '90%',
                    },
                });
            });
    }
}
